import { SchedulingByDataModel } from '../../../models/requests-management/workshift&Interruption';

export function getDaysInMonth(year: number, month: number) {
    // El mes es un número de 0 (enero) a 11 (diciembre)
    // Para obtener el último día del mes, creamos una nueva fecha en el próximo mes y restamos 1 día
    const lastDayOfMonth = new Date(year, month + 1, 0);
    return lastDayOfMonth.getDate();
}

export function getMonthName(monthNumber?: number): string {
    const monthNames = [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
    ];

    if (monthNumber !== undefined && monthNumber >= 0 && monthNumber < 12) {
        return monthNames[monthNumber];
    } else {
        const today = new Date();
        const currentMonthNumeric = today.getMonth();

        return monthNames[currentMonthNumeric];
    }
}

export const renderDate = (date: string) => {
    let newDate = new Date(date);

    return newDate.toLocaleString();
};

export const renderDateFormated = (date: string) => {
    let newDate = new Date(date);

    var yaer = newDate.getFullYear();
    var month = ('0' + (newDate.getMonth() + 1)).slice(-2); // Agrega un cero al principio si el mes es menor a 10
    var day = ('0' + newDate.getDate()).slice(-2); // Agrega un cero al principio si el día es menor a 10

    // Formatea la fecha en el formato deseado
    var dateFormated = yaer + '/' + month + '/' + day;

    return dateFormated;
};

export const reverseDate = (date: string) => {
    const arr = date.split('/');
    console.log(arr);
    return arr[2] + '-' + arr[1] + '-' + arr[0];
};

const renderClassName = (
    hasAvailability: boolean | null,
    isExceptional: boolean | null
) => {
    let name = '';

    if (hasAvailability) {
        name += 'availability ';
    }

    if (isExceptional) {
        name += 'exceptional ';
    }

    return name;
};

export const convertToEvents = (schedulings: SchedulingByDataModel[]) => {
    let events: any = [];
 
    schedulings.map((scheduling) => {
        if (scheduling.interruptionsModel.length > 0) {
            scheduling.interruptionsModel.map((interruption, i) => {
                events.push({
                    id: interruption.interruptionId,
                    title: interruption.interruptionName,
                    start:
                        interruption.date.split('T')[0] +
                        'T' +
                        interruption.startTime,
                    end:
                        interruption.date.split('T')[0] + 'T' + interruption.endTime,
                    className: interruption.isAdditionalHour
                        ? 'additional'
                        : 'interruption',

                    extendedProps: {
                        className: interruption.isAdditionalHour
                            ? 'additional'
                            : 'interruption',
                        employee: interruption.fullName,
                        documentNumber: interruption.documentNumber,
                        isAdditionalHour: interruption.isAdditionalHour,
                        observations: interruption.observations,
                        date: interruption.date,
                        startTime: interruption.startTime,
                        endTime: interruption.endTime,
                        personId: interruption.personId,
                        interruptionId: interruption.interruptionId,
                        interruptionName: interruption.interruptionName,
                        interruptionTypeId: interruption.interruptionTypeId,
                    },
                });
            });
        }

        if (scheduling?.workshiftSchedulingModel)
            if (scheduling?.workshiftSchedulingModel?.isDuplex) {
                events.push({
                    id: scheduling.workshiftSchedulingModel.schedulingId,
                    title: scheduling.workshiftSchedulingModel.workshiftName,
                    start:
                        scheduling.workshiftSchedulingModel.date.split('T')[0] +
                        'T' +
                        scheduling.workshiftSchedulingModel.firstArrival,
                    end:
                        scheduling.workshiftSchedulingModel.date.split('T')[0] +
                        'T' +
                        scheduling.workshiftSchedulingModel.firstDeparture,
                    className: `workshift ${renderClassName(
                        scheduling.workshiftSchedulingModel.hasAvailability,
                        scheduling.workshiftSchedulingModel.isExceptional
                    )}`,
                    extendedProps: {
                        className: `workshift ${renderClassName(
                            scheduling.workshiftSchedulingModel.hasAvailability,
                            scheduling.workshiftSchedulingModel.isExceptional
                        )}`,
                        employee: scheduling.workshiftSchedulingModel.fullName,
                        documentNumber:
                            scheduling.workshiftSchedulingModel.documentNumber,
                        isExceptional:
                            scheduling.workshiftSchedulingModel.isExceptional,
                        isNextDay: scheduling.workshiftSchedulingModel.isNextDay,
                        isDuplex: scheduling.workshiftSchedulingModel.isDuplex,
                        workshiftName:
                            scheduling.workshiftSchedulingModel.workshiftName,
                        startTime: scheduling.workshiftSchedulingModel.firstArrival,
                        endTime: scheduling.workshiftSchedulingModel.firstDeparture,
                        date: scheduling.workshiftSchedulingModel.date,
                        hasAvailability:
                            scheduling.workshiftSchedulingModel.hasAvailability,
                        personId: scheduling.workshiftSchedulingModel.personId,
                        workshiftId: scheduling.workshiftSchedulingModel.workshiftId,
                        costCenters: scheduling.workshiftSchedulingModel.costCenters,
                        operationCenters: scheduling.workshiftSchedulingModel.operationCenters
                    },
                });

                events.push({
                    id: scheduling.workshiftSchedulingModel.schedulingId,
                    title: scheduling.workshiftSchedulingModel.workshiftName,
                    start:
                        scheduling.workshiftSchedulingModel.date.split('T')[0] +
                        'T' +
                        scheduling.workshiftSchedulingModel.secondArrival,
                    end:
                        scheduling.workshiftSchedulingModel.date.split('T')[0] +
                        'T' +
                        scheduling.workshiftSchedulingModel.secondDeparture,
                    className: `workshift ${renderClassName(
                        scheduling.workshiftSchedulingModel.hasAvailability,
                        scheduling.workshiftSchedulingModel.isExceptional
                    )}`,
                    extendedProps: {
                        className: `workshift ${renderClassName(
                            scheduling.workshiftSchedulingModel.hasAvailability,
                            scheduling.workshiftSchedulingModel.isExceptional
                        )}`,
                        employee: scheduling.workshiftSchedulingModel.fullName,
                        documentNumber:
                            scheduling.workshiftSchedulingModel.documentNumber,
                        isExceptional:
                            scheduling.workshiftSchedulingModel.isExceptional,
                        isNextDay: scheduling.workshiftSchedulingModel.isNextDay,
                        isDuplex: scheduling.workshiftSchedulingModel.isDuplex,
                        workshiftName:
                            scheduling.workshiftSchedulingModel.workshiftName,
                        startTime: scheduling.workshiftSchedulingModel.secondArrival,
                        endTime: scheduling.workshiftSchedulingModel.secondDeparture,
                        date: scheduling.workshiftSchedulingModel.date,
                        hasAvailability:
                            scheduling.workshiftSchedulingModel.hasAvailability,
                        personId: scheduling.workshiftSchedulingModel.personId,
                        workshiftId: scheduling.workshiftSchedulingModel.workshiftId,
                        costCenters: scheduling.workshiftSchedulingModel.costCenters,
                        operationCenters: scheduling.workshiftSchedulingModel.operationCenters
                    },
                });
            } else {
                events.push({
                    id: scheduling.workshiftSchedulingModel.schedulingId,
                    title: scheduling.workshiftSchedulingModel.workshiftName,
                    start:
                        scheduling.workshiftSchedulingModel.date.split('T')[0] +
                        'T' +
                        scheduling.workshiftSchedulingModel.firstArrival,
                    end:
                        scheduling.workshiftSchedulingModel.date.split('T')[0] +
                        'T' +
                        scheduling.workshiftSchedulingModel.secondDeparture,
                    className: `workshift ${renderClassName(
                        scheduling.workshiftSchedulingModel.hasAvailability,
                        scheduling.workshiftSchedulingModel.isExceptional
                    )}`,
                    extendedProps: {
                        className: `workshift ${renderClassName(
                            scheduling.workshiftSchedulingModel.hasAvailability,
                            scheduling.workshiftSchedulingModel.isExceptional
                        )}`,
                        employee: scheduling.workshiftSchedulingModel.fullName,
                        documentNumber:
                            scheduling.workshiftSchedulingModel.documentNumber,
                        isExceptional:
                            scheduling.workshiftSchedulingModel.isExceptional,
                        isNextDay: scheduling.workshiftSchedulingModel.isNextDay,
                        isDuplex: scheduling.workshiftSchedulingModel.isDuplex,
                        workshiftName:
                            scheduling.workshiftSchedulingModel.workshiftName,
                        startTime: scheduling.workshiftSchedulingModel.firstArrival,
                        endTime: scheduling.workshiftSchedulingModel.secondDeparture,
                        date: scheduling.workshiftSchedulingModel.date,
                        hasAvailability:
                            scheduling.workshiftSchedulingModel.hasAvailability,
                        personId: scheduling.workshiftSchedulingModel.personId,
                        workshiftId: scheduling.workshiftSchedulingModel.workshiftId,
                        costCenters: scheduling.workshiftSchedulingModel.costCenters,
                        operationCenters: scheduling.workshiftSchedulingModel.operationCenters
                    },
                });
            }
    });

    return events;
};
